<template>
    <label class="label-select subtype-select">
        <select name="format" :value="value" @change="$emit('input', $event.target.value)">
            <option value="distance">Дистанционные</option>
            <option value="meet">Очные</option>
        </select>
    </label>
</template>

<script>
  export default {
    name: 'FormatSelect',

    props: {
      value: {},
    },
  };
</script>

<style scoped>

</style>